// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__22xCk","list":"BalanceDue_list__2ak5o","listRow":"BalanceDue_listRow__1wng9","total":"BalanceDue_total__1p4N7"};